import _ from 'lodash'
import React, { useCallback, useRef, useState, useEffect } from 'react'
import { TextField, Typography } from '@material-ui/core'
import InputAdornment from '@material-ui/core/InputAdornment'
import Popper from '@material-ui/core/Popper'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'
import clsx from 'clsx'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { Map, List, fromJS, isImmutable } from 'immutable'
import { processButtonAction } from '../../../store/project/processButtonAction'
import { lookupFieldOpenModal } from '../../../store/project/lookupFieldOpenModal'
import { formWidgetChangeField } from '../../../store/project/formWidgetChangeField'

export default function ReferencedField({
  field,
  value,
  label,
  onChange,
  classes,
  onBlur,
  disabled,
  elementClasses,
  disableUnderline,
  PageUID,
  index,
  styleKey,
  variant,
  rulesClasses,
  size,
  captions,
  containerClass = '',
  notchedOutlineClass = '',
  labelClassName = '',
  themeKey = '',
}) {
  const dispatch = useDispatch()
  let lookupID = `${field.widgetID}-${field.id}-${index}`
  if (String(field.widgetID).indexOf('SmartVProfile') > -1) {
    lookupID = field.widgetID
  }
  let lookup = useSelector((state) => state.getIn(['ftModals', 'lookup'], Map()))

  if (lookup.get('uid') != lookupID) {
    lookup = Map()
  }
  const [isSelectedValue, setSelectedValue] = useState(false)

  let data = useSelector((state) => state.getIn(['state', PageUID, field.widgetID, field.key], Map()))
  if (!isImmutable(data) || (lookup.get('uid') != lookupID && data.get('uid') != lookupID)) {
    data = Map()
  }
  useEffect(
    function () {
      if (!lookup.get('open') && data.get('ft_value')) {
        let statePath = [PageUID, field.widgetID]
        dispatch(formWidgetChangeField(statePath, field.key, {}))
        onChange(data.toJS())
      }
    },
    [lookup]
  )
  const [isLookupOpen, setIsLookupOpen] = useState()
  const onSelectLookupValue = (event, rowIndex) => {
    event.preventDefault()
    let statePath = [PageUID, field.widgetID]
    dispatch(formWidgetChangeField(statePath, field.key, {}))
    setSelectedValue(true)
    onChange({
      ft_value: getArrayValue('value', rowIndex),
      ft_text: getArrayValue('text', rowIndex),
    })
  }
  const onCloseSilentSearch = (event) => {
    setIsLookupOpen(false)
    if (isSelectedValue) {
      setSelectedValue(false)
      return false
    }
    if (lookup.get('open')) {
      return false
    }
    try {
      if (event.target && lookupRef.current) {
        if (event.target.getAttribute('id') == `ft_form_${field.id}`) {
          return false
        }
      }
    } catch (err) {
      console.error(err)
    }
    let uptValue = fromJS({
      ft_value: '',
      ft_text: '',
    })
    // onChange(field.field)({ target: { value: uptValue } })
  }

  const onLocalChange = (value) => {
    let statePath = [PageUID, field.widgetID]
    dispatch(formWidgetChangeField(statePath, field.key, value))
    dispatch(
      lookupFieldOpenModal(
        fromJS({
          ...field,
          doNotOpenModal: true,
        }).setIn(['props', 'captions'], captions),
        PageUID,
        lookupID,
        ['state', PageUID, field.widgetID, field.key],
        null,
        false,
        null
      )
    )

    if (window.onChangeTimeout) {
      clearTimeout(window.onChangeTimeout)
    }
    window.onChangeTimeout = setTimeout(function () {
      if (!lookup.get('open')) {
        dispatch(processButtonAction(_.get(field, ['onSearch', 'action'], List()), field.id, false, null))
        setIsLookupOpen(true)
      }
    }, 300)
  }

  const getLookupLabel = () => {
    if (data.get('ft_search') !== undefined) {
      return data.get('ft_search')
    } else if (value && value.ft_search !== undefined) {
      return value.ft_search
    } else if (value && value.ft_text) {
      return value.ft_text
    } else {
      return ''
    }
  }
  let lookupRef = useRef()

  const getArrayValue = useCallback((key, index) => {
    let valueList = _.get(data.toJS(), key, [])
    if (valueList && !_.isArray(valueList)) {
      valueList = [valueList]
    }
    if (index !== undefined) {
      return valueList[index]
    }
    return valueList
  })

  const lookupShowModal = useCallback(
    (event) => {
      dispatch(
        lookupFieldOpenModal(
          fromJS(field).setIn(['props', 'captions'], captions),
          PageUID,
          lookupID,
          ['state', PageUID, field.widgetID, field.key],
          null,
          false,
          null
        )
      )
    },
    [field, captions]
  )

  return (
    <ClickAwayListener onClickAway={onCloseSilentSearch}>
      <Typography component="div">
        <TextField
          margin="dense"
          variant={variant}
          size={size}
          value={getLookupLabel()}
          disabled={field.isUpdateable !== true || disabled}
          required={field.isMandatory}
          type="text"
          placeholder={field.placeholder}
          label={label}
          ref={lookupRef}
          onKeyDown={(event) => {
            if (event.keyCode == 13) {
              lookupShowModal(event)
            }
          }}
          className={clsx(
            `ft--theme--Prj${styleKey}-container`,
            `ft--theme--Prj${styleKey}--text`,
            `ft--theme--Prj${styleKey}--${variant}`,
            `ft--theme--${styleKey}-container`,
            `ft--theme--${styleKey}--text`,
            `ft--theme--${styleKey}--${variant}`,
            rulesClasses,
            containerClass
          )}
          FormHelperTextProps={{
            className: 'ft-helper-txt',
          }}
          fullWidth
          InputLabelProps={{
            ...(value ? { shrink: true } : {}),
            classes: {
              root: `ft--label ${labelClassName}`,
              shrink: 'ft--shrink',
              focused: 'ftfocused',
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton aria-label="Lookup data" disabled={field.isUpdateable !== true} onClick={lookupShowModal}>
                  <SearchIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
            classes: {
              focused: 'ftfocused',
              ...(variant === 'outlined' ? { notchedOutline: 'ftnotchedOutline ' + notchedOutlineClass } : {}),
            },
          }}
          inputProps={{
            id: `ft_form_${field.id}`,
            autoComplete: 'off',
          }}
          onChange={(event) => {
            setSelectedValue(false)
            onLocalChange({
              ...data.toJS(),
              ft_text: '',
              ft_value: '',
              uid: lookupID,
              ft_search: event.target.value,
            })
          }}
          onFocus={(event) => {
            if (getArrayValue('value').length > 0) {
              dispatch(processButtonAction(_.get(field, ['onSearch', 'action'], List()), field.id, false, null))
            }
            setIsLookupOpen(true)
          }}
          onBlur={onBlur}
        />
        {isLookupOpen &&
          lookupRef.current &&
          getArrayValue('value').length > 0 &&
          !lookup.get('open') &&
          data.get('uid') == lookupID && (
            <Popper
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              style={{
                width: lookupRef.current?.getBoundingClientRect?.()?.width + 'px',
                backgroundColor: 'white',
              }}
              open={true}
              anchorEl={lookupRef.current}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}>
              <div
                className={clsx(
                  `ft--theme--Prj${styleKey}--lookup`,
                  `ft--theme--Prj${styleKey}--standart`,
                  `ft--theme--Prj${styleKey}--lookup`,
                  'lookup-silent-wrap',
                  `${themeKey}--lookup`
                )}>
                {_.map(_.slice(getArrayValue('value'), 0, 5), (row, index) => (
                  <a
                    href="#"
                    onClick={(evt) => onSelectLookupValue(evt, index)}
                    className={clsx(
                      `ft--theme--Prj${styleKey}--autoSuggest`,
                      `ft--theme--Prj${styleKey}--autoSuggest`,
                      `${themeKey}--autoSuggest`
                    )}>
                    {getArrayValue('text', index)}
                  </a>
                ))}
              </div>
            </Popper>
          )}
      </Typography>
    </ClickAwayListener>
  )
}
